import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import * as businessDetailsConstants from '@features/account-settings/constants';
import { ControllersWrapper } from '@components/form/style';
import { BusinessAddress, BusinessInfo } from '@models/account';
import size from 'lodash/size';
import get from 'lodash/get';
import find from 'lodash/find';
import BusinessAddressDropdown from './BusinessAddressDropdown';
import BusinessDetailsControllers from '@features/account-settings/components/BusinessDetailsControllers';
import {
  BUSINESS_DETAILS_PHONE_FIELD_CONTROLLER_NAME,
  BUSINESS_DETAILS_COUNTRY_FIELD_CONTROLLER_NAME,
  BUSINESS_DETAILS_ADDRESS_LINE1_FIELD_CONTROLLER_NAME,
  BUSINESS_DETAILS_ADDRESS_LINE2_FIELD_CONTROLLER_NAME,
  BUSINESS_DETAILS_CITY_FIELD_CONTROLLER_NAME,
  BUSINESS_DETAILS_STATE_FIELD_CONTROLLER_NAME,
  BUSINESS_DETAILS_POSTAL_CODE_FIELD_CONTROLLER_NAME,
} from '@features/account-settings/constants';

const BusinessDetailsEditor = () => {
  const { getValues, setValue, trigger, watch } = useFormContext();

  const business = getValues(
    businessDetailsConstants.BUSINESS_DETAILS_CONTROLLER_GROUP,
  ) as BusinessInfo;

  const selectedAddressId = watch(businessDetailsConstants.SELECTED_ADDRESS_ID);
  let selectedAddress: BusinessAddress | null | undefined = null;
  if (business?.addresses) {
    selectedAddress =
      business.addresses.length == 1
        ? get(business.addresses, 0)
        : selectedAddressId
        ? find(business.addresses, { addressToken: selectedAddressId })
        : null;
  }

  useEffect(() => {
    if (business.addresses && selectedAddress != null) {
      // Set values from the address in form state
      const fieldsToUpdate: Array<[string, string | undefined]> = [
        [
          businessDetailsConstants.SELECTED_ADDRESS_ID,
          selectedAddress.addressToken,
        ],
        [
          BUSINESS_DETAILS_PHONE_FIELD_CONTROLLER_NAME,
          selectedAddress.phoneNumber,
        ],
        [
          BUSINESS_DETAILS_COUNTRY_FIELD_CONTROLLER_NAME,
          selectedAddress.countryCode,
        ],
        [
          BUSINESS_DETAILS_ADDRESS_LINE1_FIELD_CONTROLLER_NAME,
          selectedAddress.addressLine1,
        ],
        [
          BUSINESS_DETAILS_ADDRESS_LINE2_FIELD_CONTROLLER_NAME,
          selectedAddress.addressLine2,
        ],
        [BUSINESS_DETAILS_CITY_FIELD_CONTROLLER_NAME, selectedAddress.city],
        [BUSINESS_DETAILS_STATE_FIELD_CONTROLLER_NAME, selectedAddress.state],
        [
          BUSINESS_DETAILS_POSTAL_CODE_FIELD_CONTROLLER_NAME,
          selectedAddress.zipCode,
        ],
      ];
      fieldsToUpdate.forEach(([fieldName, fieldValue]) => {
        setValue(fieldName, fieldValue);
      });

      fieldsToUpdate.forEach(([fieldName]) => {
        trigger(fieldName);
      });
    }
  }, [business.addresses, setValue, trigger, selectedAddress]);

  return (
    <ControllersWrapper>
      {selectedAddress == null &&
        business.addresses &&
        size(business.addresses) > 1 && (
          <BusinessAddressDropdown businessAddresses={business.addresses} />
        )}
      {(selectedAddress || size(business.addresses) == 0) && (
        <BusinessDetailsControllers />
      )}
    </ControllersWrapper>
  );
};

export default BusinessDetailsEditor;
